module.exports = __webpack_public_path__ + "static/media/unevenshoulder_mild_left.b328e119.png";